// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { clone16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-clone': IconClone;
    }
}

/**
 * The icon component for the 'clone' icon
 */
export class IconClone extends IconSvg {
    public constructor() {
        super(clone16X16);
    }
}

registerIconSvg('icon-clone', IconClone);
export const iconCloneTag = 'nimble-icon-clone';
